import { AnyAction, Dispatch, ThunkDispatch } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from "../store";

export const useAppDispatch = (): ThunkDispatch<RootState, undefined, AnyAction> & Dispatch<AnyAction> => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
